import Formatter from '@/support/formatter';

export default class Variables {
    protected formatter = new Formatter();

    private values = {
        vat: 21,
        fee: 180,
        minFirstBid: 150,
        minBidGrow: 100,
    };

    get vat(): number {
        return this.values.vat;
    }

    get fee(): number {
        return this.values.fee;
    }

    get feeString(): string {
        return `€ ${this.formatter.formatNumber(this.values.fee)},-`;
    }

    get minFirstBid(): number {
        return this.values.minFirstBid;
    }

    get minBidGrow(): number {
        return this.values.minBidGrow;
    }
}
